module.exports = __webpack_public_path__ + "img/ultra_1_feature_01.fa6b7325.jpg";